/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ExchangeFacilitiesByFacilityResult
 */
export interface ExchangeFacilitiesByFacilityResult {
    /**
     *
     * @type {string}
     * @memberof ExchangeFacilitiesByFacilityResult
     */
    facility_id: string;
    /**
     * ExchangeFacilityMapping values keyed by the connector value persisted on a lead.
     * @type {{ [key: string]: any; }}
     * @memberof ExchangeFacilitiesByFacilityResult
     */
    exchange_mappings: { [key: string]: any; };
}

/**
 * Check if a given object implements the ExchangeFacilitiesByFacilityResult interface.
 */
export function instanceOfExchangeFacilitiesByFacilityResult(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "facility_id" in value;
    isInstance = isInstance && "exchange_mappings" in value;

    return isInstance;
}

export function ExchangeFacilitiesByFacilityResultFromJSON(json: any): ExchangeFacilitiesByFacilityResult {
    return ExchangeFacilitiesByFacilityResultFromJSONTyped(json, false);
}

export function ExchangeFacilitiesByFacilityResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExchangeFacilitiesByFacilityResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'facility_id': json['facility_id'],
        'exchange_mappings': json['exchange_mappings'],
    };
}

export function ExchangeFacilitiesByFacilityResultToJSON(value?: ExchangeFacilitiesByFacilityResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'facility_id': value.facility_id,
        'exchange_mappings': value.exchange_mappings,
    };
}
